module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-rp.jpg?v=cbdead95";